/*
 * Desktop dropdowns: open on click, then stay open until the visitor clicks.
 *
 * snippets/site-navigation.liquid turns hover on only while a dropdown is open
 * (`:disable-hover-trigger="!currentTrigger"`), so a click opens a dropdown and
 * hovering another title with a dropdown switches to it. But the menu
 * component (radix NavigationMenu, compiled into scripts.js) also closes the
 * menu whenever the pointer leaves a title or the open panel - e.g. moving
 * from Shop onto Chef Area - and has no option to turn that off.
 *
 * pointerleave does not bubble, but it still passes through a capture listener
 * on the document before reaching its target. While a dropdown is open, those
 * events are stopped there for the titles, the panel and its viewport, so the
 * component never sees them. Clicking outside, clicking the open title again,
 * Escape and hovering another dropdown title use other events and still work.
 */
(function () {
    var watched = '.site-navigation__link, .site-navigation__viewport, .site-sub-navigation';

    document.addEventListener('pointerleave', function (event) {
        var target = event.target;
        if (!(target instanceof Element) || !target.matches(watched)) return;
        var navigation = target.closest('.site-navigation');
        if (navigation && navigation.getAttribute('data-open') === 'true') {
            event.stopPropagation();
        }
    }, true);
})();
